export function isPermissionExpressionGranted(granted: readonly string[], expression?: string) {
    if (!expression) {
        return true;
    }

    return parseOrExpression(expression);

    function parseOrExpression(orExpression: string) {
        return orExpression
            .split('|')
            .some(parseAndExpression);
    }

    function parseAndExpression(andExpression: string) {
        return andExpression
            .split('&')
            .every(parseSimpleExpression);
    }

    function parseSimpleExpression(simpleExpression: string) {
        return granted.includes(simpleExpression.trim());
    }
}
